// Imports
import styled from 'styled-components/macro';
import EditorGeneratedContentContainer from '../../../../../../../shareables/foundation/front-end/components/resources/editor-generated-content-container';
import { GeneratedThemeProps } from '../../../../../../templates/template-style';


// Styled component
export const StyledEditorGeneratedContentContainer = styled(EditorGeneratedContentContainer)<{
	theme: GeneratedThemeProps;
}>`
	position: relative;
	
	p {
		margin: 0 0 0.625rem;
	}
	
	ul,
	ol {
		margin-left: 2.5em;
	}
	
	ul:not(:last-child),
	ol:not(:last-child) {
		margin-bottom: 0.62em;
	}
	
	dl:not(:last-child),
	pre:not(:last-child),
	table:not(:last-child) {
		margin-bottom: 1em;
	}
	
	code {
		background: #eee;
		padding: 0.1em 0.3em;
		border-radius: 0.3em;
		border: 0.1em solid #ddd;
	}
	
	pre {
		max-width: 100%;
		overflow-x: auto;
		
		> code {
			width: fit-content;
			display: block;
		}
	}
	
	blockquote {
		border-left: 0.3em solid #ccc;
		padding: 0.625rem 1rem;
		font-size: 1.0938rem;
	}
	
	img {
		max-width: 100%;
		margin-bottom: -0.3125rem;
	}
	
	.table td,
	.table th {
		overflow-wrap: anywhere;
	}
	
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		line-height: 1.5;
	}
`;
